module.exports = __webpack_public_path__ + "img/pit.66e1ca74.jpg";